
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//荷兰

export const lang ={
  Please_set_materialtype_in_product_page:"Ga naar de productpagina om het materiaaltype van elk product te wijzigen en in te stellen - eindproducten - halffabrikaten - accessoires.",
deleteAccount:"Uitloggen",
deleteAccountWillDeleteAllData:"Als u zich afmeldt bij uw account, worden alle gegevens verwijderd en kunt u niet meer inloggen.",
backupDatabase:"back-updatabase",
restoreDatabase:"Database herstellen",
materialtype:"Materiaal type",
Manufacturing:"Productieversie",
Professional:"Professionele versie",
Standard:"standaard editie",
product:"Afgewerkt product",
halfProduct:"Half afgewerkte producten",
components:"Accessoires",
Parent:"oudercomponent",
Children:"Subaccessoires",
Level:"Hiërarchie",
Timing:"Tijdstip",
PieceCount:"Stukwerk",
Wages:"Loon",
InternalProcess:"Intern proces",
ExternalProcess:"extern proces",
ProceName:"Proces naam",
ProceIndex:"Uitvoeringsbevel",
ChargeMan:"voornaam",
BillMethod:"Factureringsmethode",
ConsumTime:"werkuren",
Accessories:"Accessoires",
Assembly:"Monteren",
materials:"materialen",
task:"Taak",
process:"proces",
BOM:"BOM",
Production:"Productie",
RestorePurchaseOneUse:"Aankoop herstellen (één gebruiker (beperkt tot eerdere aankopen))",
buy_fail_try_again:"Klik nogmaals om te kopen",
Export:"Exporteren",
Date:"datum",
BankDetail:"bankgegevens",
Seller:"verkoper",
Buver:"koper",
Currency:"munteenheid",
CompanyName:"Bedrijfsnaam",
ProformaInvoice:"proforma factuur",
Discount:"Korting",
PayStatus:"Betalingsstatus",
ShippingStatus:"Verzendstatus",
FreightType:"Transporttype",
Shipping:"vracht",
Payment:"Betaling",
Moneyname:"valuta naam",
Tax:"belastingen",
Freight:"Vrachtkosten",
Insurance:"verzekering",
Bankfee:"bankkosten",
Qc:"Kwaliteitscertificering",
Exchangerate:"wisselkoers",
Shippingnumber:"verschepingsnummer",
ShipDate:"Verzenddatum",
Arrivedate:"aankomstdatum",
Grossweight:"bruto gewicht",
CubicWeight:"kubieke gewicht",
Totalpackages:"Totaal aantal pakketten",
Moneytype:"valuta type",
Quotedate:"offerte datum",
Validitydate:"Geldige datum",
Paymentterm:"verstrijken van het loon",
Priceterm:"prijs termijn",
DeliveryTerm:"Aflevertijd",
BankName:"banknaam",
BankAddress:"bank adres",
SwiftCode:"Bankcode",
Review:"Beoordeling",
Signfor:"Teken voor ontvangst",
Finance:"financiën",
Receiver:"Ontvanger",
Business:"bedrijf",
ContactPerson:"Contactpersoon",
Profit:"winst",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Werknemers moeten Google Chrome gebruiken. Controleer het IP-adres op de helppagina van de app van de hoofdservicecomputer en voer het adres vervolgens in de URL-kolom van andere computerbrowsers in om de login te openen",
newPassword:"nieuw paswoord",
ForgetPassword:"vergeet het wachtwoord",
ContactUs:"Neem contact met ons op / doe suggesties",
Actualpay_should_big_then_shouldpay:"De werkelijke ontvangsten kunnen niet groter zijn dan de vorderingen",
ShopAddress:"Mijn winkeladres Scan de QR-code om een ​​bestelling te plaatsen",
Submit:"indienen",
All:"alle",
OrdernumExists:"Bestelnummer bestaat al",
PermissionDenied:"geen toestemming",
StockTransfer:"Voorraad overdracht",
FromWarehouse:"Overdracht uit magazijn",
ToWarehouse:"Overbrengen naar magazijn",
PleaseUseInWebBrowser:"Gebruik de export-Excel-functie in Google Chrome",
PleasePrintInWebBrowser:"Gebruik dan de printfunctie in Google Chrome",
HistoryPrice:"historische prijs",
SerialNumber:"serienummer",
Please_Use_In_APP:"Gebruik het in computersoftware",
Please_Purchase_In_APP:"Koop het in de APP, niet in de browser",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"U kunt verbinding maken met de Postgresql-database. Uw gegevens worden opgeslagen in de Postgresql-database. Standaard hoeft u geen verbinding te maken met de Postgresql-database. De standaard is de lokale SQLite-database.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Maak verbinding met de Postgresql-database, uw gegevens worden opgeslagen in de Postgresql-database en de gegevens worden opnieuw gelezen",
Use_sqlite_data_will_store_in_local:"Met behulp van sqlite worden de gegevens op de lokale machine opgeslagen",
UsePostgresqlDatabase:"PGSQL-database gebruiken",
UseSqliteDatabase:"Met behulp van een SQLite-database",
DatabaseName:"Naam database",
Test_connect:"test verbinding",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Indien het product een kleur of maat heeft, vult u voor de initiële voorraad 0 in. Nadat u het product heeft toegevoegd, voert u de voorraad in bij de aankoop.",
my:"de mijne",
my_shop_qrcode_scan:"De QR-code van mijn winkel biedt klanten de mogelijkheid om de code te scannen om bestellingen te plaatsen. De mobiele telefoon van de klant moet op dezelfde router zijn aangesloten als uw computer.",
ip:"IK P",
port:"Haven",
orderstatus:"Bestelstatus",
image:"afbeelding",
Template:"sjabloon",
Please_select_a_excel_file:"Selecteer een bestand",
Please_select_only_one_excel_file:"Er kan slechts één bestand worden geselecteerd",
Connect_Internet_Login_again:"Maak verbinding met internet en log opnieuw in voordat u een aankoop doetGa naar de productpagina om het materiaaltype van elk product te wijzigen en in te stellen - eindproducten - halffabrikaten - accessoires.",

    productHasValidDate:'Product heeft een geldige periode',
productHasColor:'Product heeft kleurgrootte',
GeneralGoods:'Algemene goederen',
Selected:'gekozen',
RestorePurchase:'Doorgaan met kopen',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Koop permanent facturatie Enterprise Edition 1-gebruikers',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Inkooporder Enterprise Edition is onbeperkt voor gebruikers en apparaten',
Purchasing:'Kopen ... Even geduld geduld alstublieft ...',
Validdate:'Geldigheidsperiode',
Makedate:'Productiedatum',
Batch:'partij',
CheckVersion:'Controleer de versie',
Please_set_this_ip_address_on_App:'Stel dit IP-adres of IP-adres van de computer in op de APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Open deze verbinding in uw computer of mobiele browser (verbind dezelfde WiFi)',


    CheckVersion: 'Controleer versie',
You_need_to_purchase: 'Je hebt nog niets gekocht, voeg WeChat toe aan Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'Je hebt al gekocht',
New_version_available: 'Er is een nieuwe versie',
Is_the_latest_version: 'is de nieuwste versie',
    please:'alsjeblieft',
input:'invoer',
wrong:'fout',
Verifycode:'Code verifiëren',
Upload:'Uploaden',
Download:'Download',
You_need_to_purchase_to_continue_use:'U moet kopen om het gebruik voort te zetten',
CheckBuy:'Controleer Aankoop',
Exists:'bestaat',
NetworkUnavailable:'netwerk niet beschikbaar',
Today:'Vandaag',
Yesterday:'Gisteren',
ThisMonth:'Deze maand',
LastMonth:'Vorige maand',
nickname:'bijnaam',
storeName:'winkel naam',
BuyStandAlone:'koop stand-alone versie',
PermissionDenied:'Geen toestemming',
Boss:'Baas',

    login:'Log in',
    operate:'Bedienen',
    register:'Registreren',
    username:'Gebruikersnaam',
    password:'Wachtwoord',
    User:'Gebruiker',
    ok:'OK',
    back:'Terug',
    success:'Succes',
    fail:'mislukken',
    cancel:'annuleren',
    add:'Toevoegen',
    edit:'Bewerk',
    delete:'Verwijder',
    refresh:'verversen',
    close:'Dichtbij',
    cancel:'annuleren',
    return:'terugkeer',
    ElinkInvoice:'Elink Invoice',
    Purchase:'Aankoop',
    BaseData:'Basisgegevens',
    Sell:'Verkopen',
    PurchaseReturns:'Aankoop rendement',
    SellReturns:'Rendementen verkopen',
    Inventory:'Inventaris',
    Statistics:'Statistieken',
    Receivable:'ontvangbaar',
    Payable:'betaalbaar',
    Orders:'bestellingen',
    StockTransfer:'Voorraad overdracht',
    StockRecall:'Stock Recall',
    Customer:'Klant',
    Supplier:'Leverancier',
    Warehouse:'Magazijn',
    Color:'Kleur',
    Size:'Grootte',
    Category:'Categorie',
    Category2:'categorie2',
    Product:'Artikel',
    Account:'Account',
    AccountType:'Accountcategorie',
    Staff:'Personeel',
    typeone:'Categorie',
    typetwo:'Subcategorie',
    ProductName:'Productnaam',
    Specification:'Specificatie',
    Barcode:'Barcode',
    Buyprice:'Koop prijs',
    Sellprice:'Verkoop prijs',
    Wholesaleprice:'Groothandelsprijs',
    Currentstock:'Huidige voorraad',
    Unit:'Eenheid',
    Initstock:'Eerste voorraad',
    Parameter:'Parameter',
    Remark:'Opmerking',
    Supplier:'Leverancier',
    Customer:'Klant',
    Staff:'Personeel',
    Receivable:'ontvangbaar',
    payable:'betaalbaar',
    Receipts:'Receipts',
    Paid:'Betaald',
    Preferential:'preferentieel',
    DateDay:'Datum',
    OrderNum:'Bestellingsnummer',
    Name:'Naam',
    UserName:'Gebruikersnaam',
    IdNum:'ID nummer',
    BirthDay:'Verjaardag',
    SEX:'Seks',
    Female:'Vrouw',
    Male:'Mannetje',
    Select:'kiezen',
    Address:'Adres',
    Phone:'Telefoon',
    Email:'E-mail',
    CardNum:'Kaartnummer',
    Price:'Prijs',
    QTY:'Aantal',
    SupplierCategory:'Leverancierscategorie',
    CustomerCategory:'Klantcategorie',
    Power:'macht',
    Role:'Rol',
    save:'Opslaan',
    image:'beeld',
    search:'Zoeken',
    Year:'Jaar',
    Month:'Maand',
    Day:'Dag',
    Total:'Totaal',
    WorkReport:'Werkrapport',
    Leave:'Het verlof',
    CheckIn:'Check in',
    Announcement:'Aankondiging',
    Approval:'Goedkeuring',
    Tracking:'Tracking',
    Bill:'Bill',
    OrdersDetail:'Detail orders',
    Expense:'Kosten',
    Income:'Inkomen',
    Userfor:'Gebruiker voor',
    Amount:'Bedrag',
    Title:'Titel',
    News:'Nieuws',
    SelectFile:'Selecteer bestand',
    Content:'Inhoud',
    Cost:'Kosten',
    ApprovalUser:'Goedkeuring gebruiker',
    ApprovalStatus:'Goedkeuringsstatus',
    ApprovalRemark:'Goedkeuring Opmerking',
    ApprovalDate:'Datum van goedkeuring',
    SubmitDate:'Datum verzenden',
    Status:'staat',
    FromDateTime:'Van datum tijd',
    ToDateTime:'To Date Time',
    Subject:'Onderwerpen',
    Latitude:'Breedtegraad',
    Longitude:'Lengtegraad',
    Print:'Afdrukken',
    DataTrans:'Data Trans',
    OA:'OA',
    Setting:'set',
    Help:'Helpen',
    ScanOpenInPhone:'Scan Open in telefoon',
    Building:'Gebouw',
    Room:'Kamer',
    HotelCheckIn:'Check in',
    CheckOut:'Uitchecken',
    Hotel:'Hotel',
    Checkintime:'Check-in tijd',
    Checkouttime:'Check-uit tijd',
    Deposit:'Storting',
    Cost:'Kosten',
    RoomNum:'Kamer Num',
    Rent:'Huur',
    costday:'costday',
    rent:'huur',
    waternum:'Water mate',
    electricnum:'Elektrisch diploma',
    gasnum:'Gasgraad',
    watercost:'water kosten',
    electriccost:'elektrische kosten',
    gascost:'gaskosten',
    cleaningcost:'schoonmaakkosten',
    networkcost:'netwerkkosten',
    tvcost:'tv-kosten',
    managecost:'kosten beheren',
    othercost:'andere kosten',
    totalcost:'totale prijs',
    remark:'opmerking',
    addtime:'Voeg tijd toe',
    OpenInBrowser:'Open in de browser',
    InventoryProfit:'Voorraadwinst',
    InventoryLoss:'Voorraadverlies',
    Buy:'Kopen',



Refresh:'Vernieuwen',
Add:'Toevoegen',
Search:'Zoeken',
Records:'records',
}



// WEBPACK FOOTER //
// ./src/lang/nl.js